<template>
    <div class="field">
        <label class="label">{{ $t("prepare-text.user-receiver") }}</label>
        <div class="control">
            <div v-if="users.length > 0" class="is-fullwidth">
                <p v-for="user in users" :key="user.id">
                    <input
                        type="checkbox"
                        :value="user"
                        :id="user.id"
                        v-model="selectedUsers"
                    />
                    <label class="ml-1" :for="user.id">{{ user.name }}</label>
                </p>
            </div>
            <div v-else>
                <p>{{ $t("prepare-text.not-loged-users") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "user-select",
    props: {
        value: Array,
    },
    data() {
        return {
            selectedUsers: [],
        };
    },
    watch: {
        selectedUsers(selectedUsers) {
            this.$emit("input", selectedUsers);
        },
    },
    computed: {
        ...mapGetters("conference", ["getOtherUsers"]),
        users() {
            return this.getOtherUsers;
        },
    },
};
</script>